export default __webpack_public_path__ + "static/media/hero-chiSiamoImage4Medium.801f3eaf.jpg";